module.exports = __webpack_public_path__ + "img/p5toplogo.7e9a7d26.png";